import React from "react";
import { CloseIcon } from "app/components/Icons";
import EditIcon from "app/components/Icons/EditIcon";
import CheckIcon from "app/components/Icons/CheckIcon";
import CustomTooltip from "app/components/Tooltip";

type HeaderProps = {
  fileName?: string;
  onRenameSubmit?: (name: string) => void;
};

const HeaderFileName: React.FC<HeaderProps> = ({
  fileName,
  onRenameSubmit,
}) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [draftName, setDraftName] = React.useState(fileName || "");
  const [isRenameHovered, setIsRenameHovered] = React.useState(false);

  React.useEffect(() => {
    setDraftName(fileName || "");
  }, [fileName]);

  const handleRenameCommit = () => {
    const trimmed = draftName.trim();
    setIsEditing(false);
    if (!trimmed || trimmed === (fileName || "")) return;
    onRenameSubmit?.(trimmed);
  };

  const handleRenameCancel = () => {
    setIsEditing(false);
    setDraftName(fileName || "");
  };

  return (
    <div className="flex items-center min-w-0 w-0 flex-1 max-w-[45%]">
      {isEditing ? (
        <div className="h-[32px] border border-white/70 rounded-[2px] px-2 flex items-center gap-2 min-w-0">
          <input
            value={draftName}
            onChange={(e) => setDraftName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleRenameCommit();
              }
              if (e.key === "Escape") {
                e.preventDefault();
                handleRenameCancel();
              }
            }}
            autoFocus
            className="[background-color:transparent!important] [background:transparent] [background-color:transparent] [webkit-text-fill-color:#FFFFFF] [webkit-box-shadow:0_0_0_1000px_transparent_inset] [box-shadow:none] appearance-none border-none shadow-none text-white text-[18px] leading-[27px] font-medium min-w-0 flex-1 focus:outline-none"
            aria-label="Rename attachment"
          />
          <button
            type="button"
            onClick={handleRenameCommit}
            className="shrink-0 focus:outline-none"
            aria-label="Confirm rename"
          >
            <CheckIcon size={18} color="#FFFFFF" />
          </button>
          <button
            type="button"
            onClick={handleRenameCancel}
            className="shrink-0 focus:outline-none"
            aria-label="Cancel rename"
          >
            <CloseIcon size="16" color="#FFFFFF" />
          </button>
        </div>
      ) : (
        <div className="h-[32px] rounded-[2px] px-2 flex items-center gap-2 min-w-0">
          <span className="text-white text-[18px] leading-[27px] font-medium truncate">
            {fileName || "Preview"}
          </span>
          {onRenameSubmit ? (
            <CustomTooltip
              text="Rename"
              position="bottom"
              disabled={!isRenameHovered}
            >
              <span
                className="inline-flex"
                onMouseEnter={() => setIsRenameHovered(true)}
                onMouseLeave={() => setIsRenameHovered(false)}
              >
                <button
                  type="button"
                  onClick={() => setIsEditing(true)}
                  className="shrink-0 focus:outline-none"
                  aria-label="Edit file name"
                >
                  <EditIcon size={20} color="#FFFFFF" />
                </button>
              </span>
            </CustomTooltip>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default HeaderFileName;
